<template>
  <el-form-item :label="label" :prop="name" :class="[visible ? 'active' : '']">
    <el-popover
      placement="bottom-start"
      v-model="showSelect"
      :visible-arrow="false"
      popper-class="country-code-drop-wrapper"
      width="204"
    >
      <el-input slot="reference" v-bind="$attrs" v-on="listeners" :placeholder="placeholder" readonly></el-input>
      <el-input :placeholder="$t('common.search')" name="search" v-model="searchValue" @keyup.enter.native="onSearchLanguage" @input="onSearchLanguage">
      </el-input>
      <div class="list-wrapper">
        <div
          v-for="(item, index) in codesList"
          :key="item.code + index"
          :class="['list-item', $attrs.value === item.code ? 'active' : '']"
          @click="() => onCodesSelect(item)"
        >
          <div class="view-container">
            <span class="view-value">{{ item.codeValue }}</span>
            <span class="view-label">{{ item.codeLabel }}</span>
          </div>
        </div>
      </div>
    </el-popover>
    <div class="active-line"></div>
  </el-form-item>
</template>

<script>
export default {
  name: 'CountryCodeSelect',
  props: { name: String, label: String, placeholder: String, codes: Array },
  data() {
    return {
      focus: false,
      searchValue: '',
      showSelect: false,
      codesList: this.codes
    };
  },
  methods: {
    onSearchLanguage() {
      if (this.searchValue) {
        this.codesList = this.codes.filter(e => {
          const lowerCaseLabel = e.value.toLocaleLowerCase();
          const lowerCaseValue = this.searchValue.toLocaleLowerCase();
          return lowerCaseLabel.includes(lowerCaseValue);
        });
      }
    },
    onCodesSelect(itemData) {
      this.$emit('select', itemData);
      this.showSelect = false;
      // this.searchValue = '';
    }
  },
  watch: {
    searchValue(val) {
      if (!val) {
        this.codesList = this.codes;
      }
    },
    codes(values) {
      this.codesList = values;
    }
  },
  computed: {
    visible() {
      return this.$attrs.value || this.focus || this.placeholder;
    },
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: event => this.$emit('input', event),
        focus: event => (this.focus = true),
        blur: event => (this.focus = false)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.country-code-drop-wrapper {
  .list-wrapper {
    height: 200px;
    overflow: auto;
    margin-top: 16px;
  }

  .list-item {
    color: #031f45;
    padding: 8px;
    padding: 6px 8px;
    margin-right: 4px;
    margin-bottom: 8px;
    border-radius: 12px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      color: #0051ff;
    }
    &.active {
      font-weight: 700;
      color: #0051ff;
    }
  }
  .view-container {
    display: flex;
    font-size: 14px;
    .view-value {
      @include rtl-sass-prop(padding-right, padding-left, 8px);
    }
  }
}
</style>
